import { useParams } from 'react-router-dom';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import '../../styles/ProductDetails.css'; 
import hammerdrill from '../../assets/img/hammerdrill.jpeg';
import maxmechgen from '../../assets/img/image.png';
import maxmechdrill from '../../assets/img/maxmechdrill.jpg';
import weldingmachine from '../../assets/img/weldingmachine.jpg';

const products = [
  {
    id: 'hammer-drill',
    name: 'Hammer Drill',
    image: hammerdrill,
    price: '₦0',
    description: 'Compact, high-speed drill ideal for masonry, wood, and metal. Built for precision and durability.',
    specs: [
      'Rated Power: 710W',
      'Chuck Size: 13mm',
      'Speed: 0-3000 RPM',
      'Weight: 2.2kg',
      'Corded Electric',
    ],
    availability: 'In Stock',
    warranty: '6 Months Warranty',
  },
  {
    id: 'maxmech-gasoline-generator',
    name: 'Maxmech Gasoline Generator',
    image: maxmechgen,
    price: '₦0',
    description: 'Reliable 100% copper generator for home or site use. Stable output and long runtime.',
    specs: [
      'Power Output: 2.5KVA',
      'Fuel: Petrol (Gasoline)',
      'Tank Capacity: 15L',
      'Engine Type: Single-cylinder, 4-stroke',
      '100% Copper Coil',
    ],
    availability: 'Limited Stock',
    warranty: '1 Year Warranty',
  },
  {
    id: 'maxmech-20v-impact-wrench',
    name: 'Maxmech 20V Impact Wrench',
    image: maxmechdrill,
    price: '₦0',
    description: 'Powerful cordless wrench for automotive and heavy-duty tasks. Lightweight and easy to handle.',
    specs: [
      'Voltage: 20V Li-ion',
      'Torque: 300 Nm',
      'Battery: 2.0Ah Rechargeable',
      'Speed: 0-2200 RPM',
      'Includes Battery & Charger',
    ],
    availability: 'In Stock',
    warranty: '1 Year Warranty',
  },
  {
    id: 'welding-machine',
    name: 'Welding Machine',
    image: weldingmachine,
    price: '₦0',
    description: 'Heavy-duty welding machine with overheat protection and smooth arc performance.',
    specs: [
      'Voltage: 220V',
      'Output Current: 20-250A',
      'Duty Cycle: 60%',
      'Cooling: Fan-Cooled',
      'Digital Display',
    ],
    availability: 'In Stock',
    warranty: '6 Months Warranty',
  },
];

const ProductDetails = () => {
  const { productId } = useParams();
  const product = products.find((item) => item.id === productId);

  if (!product) {
    return (
      <div>
        <Header />
        <div className="product-details">
          <h2>Product not found</h2>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="product-details">
        <img src={product.image} alt={product.name} className="product-imge" />
        <div className="product-info">
          <h1>{product.name}</h1>
          <p className="price">{product.price}</p>
          <p className="description">{product.description}</p>

          <div className="specs">
            <h3>Specifications:</h3>
            <ul>
              {product.specs.map((spec, index) => (
                <li key={index}>{spec}</li>
              ))}
            </ul>
          </div>

          <p><strong>Availability:</strong> {product.availability}</p>
          <p><strong>Warranty:</strong> {product.warranty}</p>

          <a
            href={`https://wa.me/2348165385299?text=Hello, I'm interested in the ${product.name} I saw on your website.`}
            className="buy-now"
            target="_blank"
            rel="noopener noreferrer"
          >
            Buy on WhatsApp
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetails;
